import { render, staticRenderFns } from "./THGCarFilters.vue?vue&type=template&id=27709ad3&scoped=true"
import script from "./THGCarFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCarFilters.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGCarFilters.vue?vue&type=style&index=0&id=27709ad3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27709ad3",
  null
  
)

export default component.exports